export default __webpack_public_path__ + "static/media/new-11.501609b5.png";